import { render, staticRenderFns } from "./UnPaidRegistration.vue?vue&type=template&id=30d6887c"
import script from "./UnPaidRegistration.vue?vue&type=script&lang=js"
export * from "./UnPaidRegistration.vue?vue&type=script&lang=js"
import style0 from "./UnPaidRegistration.vue?vue&type=style&index=0&id=30d6887c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports